import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, NgZone } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ServicoService } from '../../../services/servico.service';
import { FinanceiroService } from '../../../services/financeiro.service';
import { UsuarioService } from '../../../services/usuario.service';
import { environment } from '../../../../../../environments/environment';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-financeiro',
  standalone: false,
  templateUrl: './financeiro.component.html',
  styleUrl: './financeiro.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FinanceiroComponent implements OnInit {
  servicos: any[] = [];
  servicosFiltrados: any[] = [];
  usuariosFiltro: { usuarioId: string, nome: string }[] = [];
  filtroUsuarioId: string = '';
  filtroDataInicio: string = this.getDataSeteDiasAtrasInput();
  filtroDataFim: string = this.getDataHojeInput();
  showFiltros: boolean = false;
  filtroStatus: string = 'Concluida'; // Status padrão: Concluído (pode ser Concluído ou Negado)
  filtroNumeroOrdem: number | null = null;
  filtroMatricula: string = '';
  filtroNomeConsumidor: string = '';
  filtroCpf: string = '';
  filtroCnpj: string = '';
  filtroCep: string = '';
  filtroLogradouro: string = '';
  filtroBairro: string = '';
  filtroCidade: string = '';
  filtroEstado: string = '';
  filtroNumero: string = '';
  carregando = false;
  erro: string | null = null;
  // sem paginação — exibiremos todos os registros retornados pelo endpoint
  Math = Math;

  constructor(
    public servicoService: ServicoService,
    public financeiroService: FinanceiroService,
    public usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {
    this.usuarioService.carregarTodosColaboradores().subscribe({
      next: (usuarios: any[]) => {
        this.usuariosFiltro = usuarios.map(u => ({ usuarioId: u.usuarioId, nome: u.nome }));
        this.aplicarFiltro();
        this.cdr.markForCheck();
        try { this.cdr.detectChanges(); } catch (e) { /* ignore if view not ready */ }
      },
      error: () => {
        this.usuariosFiltro = [];
        this.aplicarFiltro();
        this.cdr.markForCheck();
        try { this.cdr.detectChanges(); } catch (e) { /* ignore if view not ready */ }
      }
    });
  }

  aplicarFiltro(): void {
    this.carregando = true;
    this.spinner.show();
    this.erro = null;
    this.showFiltros = false;
    this.buscarServicos();
    this.cdr.markForCheck();
    try { this.cdr.detectChanges(); } catch (e) { /* ignore if view not ready */ }
  }

  // Retorna o total de registros atualmente filtrados (útil para exibição no template)
  get totalRegistros(): number {
    return Array.isArray(this.servicosFiltrados) ? this.servicosFiltrados.length : 0;
  }

  resetarERecarregar(): void {
    this.resetarFiltro();
    this.aplicarFiltro();
  }

  buscarServicos(): void {
    // Buscar relatórios de vistorias usando o serviço financeiro com filtros
    this.financeiroService.getRelatoriosVistorias({
      DataInicial: this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined,
      DataFinal: this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined,
      NomeConsumidor: this.filtroNomeConsumidor || undefined,
      CpfOuCnpj: this.filtroCpf || undefined,
      Cep: this.filtroCep || undefined,
      Logradouro: this.filtroLogradouro || undefined,
      Bairro: this.filtroBairro || undefined,
      Cidade: this.filtroCidade || undefined,
      Estado: this.filtroEstado || undefined,
      Numero: this.filtroNumero || undefined,
      NumeroOS: undefined,
      StatusOS: this.filtroStatus
    }).subscribe({
      next: (res) => {
        this.ngZone.run(() => {
          const items = Array.isArray(res) ? res : (res.itens || res.items || []);
          this.servicos = items;
          this.servicosFiltrados = this.servicos;
          this.carregando = false;
          this.spinner.hide();
          this.cdr.markForCheck();
          try { this.cdr.detectChanges(); } catch (e) { /* ignore if view not ready */ }
        });
      },
      error: () => {
        this.ngZone.run(() => {
          this.erro = 'Erro ao carregar relatório';
          this.carregando = false;
          this.spinner.hide();
          this.cdr.markForCheck();
          try { this.cdr.detectChanges(); } catch (e) { /* ignore if view not ready */ }
        });
      }
    });
  }

  resetarFiltro(): void {
    this.filtroUsuarioId = '';
    this.filtroDataInicio = this.getDataSeteDiasAtrasInput();
    this.filtroDataFim = this.getDataHojeInput();
    this.aplicarFiltro();
  }

  formatNumeroOS(item: any): string {
    if (!item) return '-';
    const candidato = item.numeroOS || item.numeroOs || item.numeroOrdem || item.numero || item.ordemNumero || item.numeroOrdemFormatado || item.osNumero || item.osNumero1 || item.osNumero2 || item.osNumero3;
    if (candidato === undefined || candidato === null || candidato === '') return '-';
    const s = candidato.toString();
    if (/[^0-9]/.test(s) || /^0+/.test(s)) return s;
    return s.padStart(4, '0');
  }

  trackByServico(index: number, item: any): any {
    return item && (item.servicoId || item.id || item.cadastroId || item.recadastroId) ? (item.servicoId || item.id || item.cadastroId || item.recadastroId) : index;
  }



  getDataHojeInput(): string {
    const hoje = new Date();
    return hoje.toISOString().split('T')[0];
  }

  getDataSeteDiasAtrasInput(): string {
    const hoje = new Date();
    const seteDiasAtras = new Date(hoje);
    seteDiasAtras.setDate(hoje.getDate() - 0);
    return seteDiasAtras.toISOString().split('T')[0];
  }

  onFiltroDataFimChange(): void {
    if (!this.filtroDataFim) {
      return;
    }
    setTimeout(() => {
      try { this.cdr.detectChanges(); } catch (e) { /* ignore if view not ready */ }
    }, 50);
  }

  maskCpf(cpf: string): string {
    if (!cpf) return '';
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11) return cpf;
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  formatCpfOuCnpj(valor: any): string {
    if (!valor && valor !== 0) return '-';
    const s = String(valor).replace(/\D/g, '');
    if (s.length === 11) return this.maskCpf(s);
    if (s.length === 14) return this.maskCnpj(s);
    return valor;
  }

  maskCnpj(cnpj: any): string {
    if (!cnpj) return '';
    cnpj = String(cnpj).replace(/\D/g, '');
    if (cnpj.length !== 14) return cnpj;
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  maskTelefone(telefone: string): string {
    if (!telefone) return '';
    telefone = telefone.replace(/\D/g, '');
    if (telefone.length === 11) {
      return telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
    if (telefone.length === 10) {
      return telefone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    return telefone;
  }

  getFullImageUrl(url: string): string {
    if (!url) return '';
    if (/^https?:\/\//.test(url)) return url;
    const base = environment.mediaUrl.replace(/\/$/, '');
    const path = url.startsWith('/') ? url : '/' + url;
    return base + path;
  }

  getUsuarioNome(usuarioId: string): string {
    if (!usuarioId) return '-';
    const usuario = this.usuariosFiltro.find((u: any) => u.usuarioId === usuarioId);
    return usuario ? usuario.nome : '-';
  }

  getTipoServico(item: any): string {
    if (item.recadastroId && item.recadastroId !== "00000000-0000-0000-0000-000000000000") {
      return 'recadastro';
    }
    return 'cadastro';
  }

  getDataServico(item: any): string {
    if (this.getTipoServico(item) === 'recadastro') {
      return item.dataRecadastramento || '-';
    }
    return item.dataCadastro || '-';
  }

  getDataVistoria(item: any): Date | string {
    if (!item) return '-';
    // Tenta vários campos possíveis de data
    const dataCandidata = item.dataCadastro ||
      item.dataRecadastramento ||
      item.dataHoraInicio ||
      item.dataServico ||
      item.dataVistoria ||
      item.dataCriacao ||
      item.data;

    if (!dataCandidata) return '-';

    // Converte a string ISO para objeto Date
    try {
      const dataConvertida = new Date(dataCandidata);
      return dataConvertida;
    } catch (e) {
      return dataCandidata;
    }
  }



  getEnderecoCompleto(item: any): string {
    if (!item) return '-';

    const endereco = item.endereco || item;
    const partes = [];

    if (endereco.logradouro) partes.push(endereco.logradouro);
    if (endereco.numero) partes.push(`nº ${endereco.numero}`);
    if (endereco.bairro) partes.push(endereco.bairro);
    if (endereco.cidade) partes.push(endereco.cidade);
    if (endereco.estado) partes.push(endereco.estado);

    return partes.length > 0 ? partes.join(', ') : '-';
  }

  /**
   * Exporta os dados filtrados da tabela para Excel
   * Com título "Relatório de Vistorias" e logos
   * Busca TODOS os registros, não apenas a página atual
   */
  async exportarParaExcel(): Promise<void> {
    try {
      this.spinner.show();

      // Busca TODOS os registros com os mesmos filtros aplicados, sem paginação
      let todosRegistros: any[] = [];

      await new Promise<void>((resolve, reject) => {
        this.financeiroService.getRelatoriosVistorias({
          DataInicial: this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined,
          DataFinal: this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined,
          NomeConsumidor: this.filtroNomeConsumidor || undefined,
          CpfOuCnpj: this.filtroCpf || undefined,
          Cep: this.filtroCep || undefined,
          Logradouro: this.filtroLogradouro || undefined,
          Bairro: this.filtroBairro || undefined,
          Cidade: this.filtroCidade || undefined,
          Estado: this.filtroEstado || undefined,
          Numero: this.filtroNumero || undefined,
          NumeroOS: undefined,
          StatusOS: this.filtroStatus
        }).subscribe({
          next: (res) => {
            this.ngZone.run(() => {
              todosRegistros = res.itens || res.items || res || [];
              resolve();
            });
          },
          error: (err) => {
            this.ngZone.run(() => {
              console.error('Erro ao buscar todos os registros:', err);
              reject(err);
            });
          }
        });
      });

      // Se não houver registros, mostra mensagem e cancela
      if (todosRegistros.length === 0) {
        this.spinner.hide();
        alert('Nenhum registro encontrado para exportar.');
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Relatório');

      // Função auxiliar para baixar imagem e converter para base64
      const getImageBase64 = async (url: string): Promise<string | null> => {
        try {
          const response = await fetch(url);
          const blob = await response.blob();
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64 = reader.result as string;
              resolve(base64.split(',')[1]);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        } catch (error) {
          console.error('Erro ao carregar imagem:', url, error);
          return null;
        }
      };

      // Baixa as imagens dos logos
      const [logoCedaeBase64, logoVibetexBase64] = await Promise.all([
        getImageBase64('https://cedae.vibetex.com.br/images/cedae2.jpg'),
        getImageBase64('https://cedae.vibetex.com.br/images/logo_vibetex.png')
      ]);

      let imagemCedaeId: number | null = null;
      let imagemVibetexId: number | null = null;

      if (logoCedaeBase64) {
        imagemCedaeId = workbook.addImage({
          base64: logoCedaeBase64,
          extension: 'jpeg',
        });
      }

      if (logoVibetexBase64) {
        imagemVibetexId = workbook.addImage({
          base64: logoVibetexBase64,
          extension: 'png',
        });
      }

      // Linha 1: Título dinâmico baseado no status filtrado
      worksheet.mergeCells('C1:K1');
      const titleCell = worksheet.getCell('C1');
      const tituloStatus = this.filtroStatus === 'Negada' ? 'Negativa' : 'Concluídas';
      titleCell.value = `Medição de vistorias - ${tituloStatus}`;
      titleCell.font = { bold: true, size: 14, color: { argb: 'FFFFFFFF' } };
      titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
      titleCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF0062CC' }
      };
      worksheet.getRow(1).height = 50;

      if (imagemVibetexId !== null) {
        worksheet.addImage(imagemVibetexId, {
          tl: { col: 2.1, row: 0.1 },
          ext: { width: 60, height: 55 }
        });
      }

      if (imagemCedaeId !== null) {
        worksheet.addImage(imagemCedaeId, {
          tl: { col: 10.25, row: 0.1 },
          ext: { width: 60, height: 55 }
        });
      }

      worksheet.addRow([]);

      worksheet.mergeCells('C3:K3');
      const cadastroRow = worksheet.getRow(3);
      cadastroRow.getCell('C').value = 'Cadastro';
      cadastroRow.getCell('C').font = { bold: true, size: 11, color: { argb: 'FFFFFFFF' } };
      cadastroRow.getCell('C').alignment = { vertical: 'middle', horizontal: 'center' };
      cadastroRow.getCell('C').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF0062CC' }
      };
      cadastroRow.height = 20;

      worksheet.addRow([]);

      worksheet.getColumn(1).width = 3;
      worksheet.getColumn(2).width = 3;
      worksheet.getColumn(3).width = 6;   // #
      worksheet.getColumn(4).width = 30;  // ENDEREÇO (antes estava em 5)
      worksheet.getColumn(5).width = 8;   // Nº
      worksheet.getColumn(6).width = 25;  // MUNICÍPIO
      worksheet.getColumn(7).width = 23;  // BAIRRO
      worksheet.getColumn(8).width = 19;  // SERVIÇO EXECUTADO
      worksheet.getColumn(9).width = 15;  // Nº VISTORIA
      worksheet.getColumn(10).width = 12; // DATA
      worksheet.getColumn(11).width = 12; // STATUS

      const headerRow = worksheet.getRow(5);
      // Coluna LOGRADOURO removida — colunas deslocadas para a esquerda
      headerRow.values = ['', '', '#', 'ENDEREÇO', 'Nº', 'MUNICÍPIO', 'BAIRRO', 'SERVIÇO EXECUTADO', 'Nº VISTORIA', 'DATA', 'STATUS'];
      headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
      headerRow.height = 25;

      for (let col = 3; col <= 11; col++) {
        headerRow.getCell(col).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF0062CC' }
        };
      }

      todosRegistros.forEach((servico, index) => {
        let logradouroTipo = '';
        let logradouroNome = '';
        let enderecoCompleto = '';
        let numero = '';
        let municipio = '';
        let bairro = '';

        if (servico.endereco) {
          logradouroTipo = servico.endereco.logradouroTipo ||
            servico.endereco.tipoLogradouro ||
            servico.endereco.tipo ||
            servico.endereco.tipoEndereco || '';

          logradouroNome = servico.endereco.logradouro ||
            servico.endereco.nomeLogradouro ||
            servico.endereco.nome ||
            servico.endereco.rua || '';

          numero = servico.endereco.numero ||
            servico.endereco.numeroEndereco ||
            servico.endereco.numeroLogradouro || '';

          municipio = servico.endereco.municipio ||
            servico.endereco.cidade ||
            servico.endereco.nomeMunicipio || '';

          bairro = servico.endereco.bairro ||
            servico.endereco.nomeBairro || '';
        }

        // Fallback: tenta campos diretos no objeto principal
        if (!logradouroTipo) {
          logradouroTipo = servico.logradouroTipo ||
            servico.tipoLogradouro ||
            servico.tipo || '';
        }

        if (!logradouroNome) {
          logradouroNome = servico.logradouro ||
            servico.nomeLogradouro ||
            servico.rua || '';
        }

        if (!numero) {
          numero = servico.numero ||
            servico.numeroEndereco ||
            servico.numeroLogradouro || '';
        }

        if (!municipio) {
          municipio = servico.municipio ||
            servico.cidade ||
            servico.nomeMunicipio || '';
        }

        if (!bairro) {
          bairro = servico.bairro ||
            servico.nomeBairro || '';
        }

        // Monta o endereço completo
        enderecoCompleto = logradouroTipo && logradouroNome
          ? `${logradouroTipo} ${logradouroNome}`.trim()
          : logradouroNome || logradouroTipo || '';

        // Se não encontrou tipo de logradouro separado, tenta extrair do endereço completo
        if (!logradouroTipo && enderecoCompleto) {
          const tiposLogradouro = ['Rua', 'Avenida', 'Av', 'Travessa', 'Trav', 'Alameda', 'Praça',
            'Rodovia', 'Estrada', 'Largo', 'Viela', 'Beco', 'Conjunto'];

          for (const tipo of tiposLogradouro) {
            const regex = new RegExp(`^${tipo}\\s`, 'i');
            if (regex.test(enderecoCompleto)) {
              logradouroTipo = tipo;
              break;
            }
          }
        }

        // Se ainda não tem endereço completo, usa o método getEnderecoCompleto
        if (!enderecoCompleto) {
          enderecoCompleto = this.getEnderecoCompleto(servico);

          // Tenta extrair tipo novamente do endereço obtido
          if (!logradouroTipo && enderecoCompleto && enderecoCompleto !== '-') {
            const tiposLogradouro = ['Rua', 'Avenida', 'Av', 'Travessa', 'Trav', 'Alameda', 'Praça',
              'Rodovia', 'Estrada', 'Largo', 'Viela', 'Beco', 'Conjunto'];

            for (const tipo of tiposLogradouro) {
              const regex = new RegExp(`^${tipo}\\s`, 'i');
              if (regex.test(enderecoCompleto)) {
                logradouroTipo = tipo;
                break;
              }
            }
          }
        }

        let dataFormatada = '';
        // Considera vários campos possíveis de data, incluindo dataCadastro que vem do endpoint
        const candidatoDataStr = servico.dataServico || servico.dataRecadastramento || servico.dataCadastroOriginal || servico.dataCadastro || servico.dataHoraInicio || servico.dataCriacao || servico.data;
        if (candidatoDataStr) {
          // Alguns backends retornam formatos com muita precisão; Date aceita strings ISO, mas garantimos parsing robusto
          const data = new Date(candidatoDataStr);
          if (!isNaN(data.getTime())) {
            const dia = String(data.getDate()).padStart(2, '0');
            const mes = String(data.getMonth() + 1).padStart(2, '0');
            const ano = data.getFullYear();
            dataFormatada = `${dia}/${mes}/${ano}`;
          } else {
            // Fallback: tenta extrair a parte da data (yyyy-mm-dd) se for string
            if (typeof candidatoDataStr === 'string') {
              const m = candidatoDataStr.match(/(\d{4})-(\d{2})-(\d{2})/);
              if (m) {
                dataFormatada = `${m[3]}/${m[2]}/${m[1]}`;
              }
            }
          }
        }

        const tipo = servico.tipoOS || 'Cadastro';
        const numeroVistoria = this.formatNumeroOS(servico);

        // Define status e cor dinamicamente
        const statusTexto = servico.statusOS || this.filtroStatus;
        const corStatus = statusTexto === 'Negada' || statusTexto === 'Negado' ? 'FFDC3545' : 'FF28A745'; // Vermelho para Negado, Verde para Concluído

        // Define cor do tipo de serviço (Cadastro ou Recadastro) - cores mais suaves
        const corTipo = tipo === 'Recadastro' ? 'FFE1BEE7' : 'FFB2EBF2'; // Roxo claro para Recadastro, Azul ciano claro para Cadastro
        const corTextoTipo = 'FF000000'; // Texto preto

        // Monta a linha sem a coluna LOGRADOURO (foi removida)
        const row = worksheet.addRow([
          '', '', index + 1, enderecoCompleto || '-',
          numero || '-', municipio || '-', bairro || '-', tipo,
          numeroVistoria, dataFormatada || '-', statusTexto
        ]);

        row.getCell(8).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: corTipo }
        };
        row.getCell(8).font = {
          color: { argb: corTextoTipo },
          bold: true
        };
        row.getCell(8).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };

        row.getCell(11).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: corStatus }
        };
        row.getCell(11).font = {
          color: { argb: 'FFFFFFFF' },
          bold: true
        };
        row.getCell(11).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };
      });

      // Aplica bordas
      worksheet.eachRow((row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
          // Ajustado para considerar colunas 3..11 (coluna L removida)
          if (colNumber >= 3 && colNumber <= 11) {
            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            };

            if (rowNumber > 4) {
              if (colNumber === 3) {
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
                cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FFF8F9FA' }
                };
                cell.font = { bold: true };
              } else if (colNumber === 4) {
                // Coluna ENDEREÇO - alinhada à esquerda
                cell.alignment = { vertical: 'middle', horizontal: 'left' };
              } else {
                // Demais colunas - centralizadas
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
              }
            }
          }
        });
      });

      // Estatísticas baseadas em TODOS os registros
      const totalRegistros = todosRegistros.length;

      const contagemPorMunicipio: { [key: string]: number } = {};
      todosRegistros.forEach((servico) => {
        // Busca o município com fallbacks
        let municipio = '';

        if (servico.endereco) {
          municipio = servico.endereco.municipio || servico.endereco.cidade || servico.endereco.nomeMunicipio || '';
        }

        if (!municipio) {
          municipio = servico.municipio || servico.cidade || servico.nomeMunicipio || '';
        }

        municipio = String(municipio || '').trim();

        if (!municipio) {
          municipio = 'Não informado';
        } else {

          municipio = municipio.replace(/\s+/g, ' ').trim();

          municipio = municipio
            .toLowerCase()
            .split(' ')
            .map(palavra => {
              if (!palavra) return '';
              return palavra.charAt(0).toUpperCase() + palavra.slice(1);
            })
            .filter(p => p) // Remove strings vazias
            .join(' ');
        }

        if (contagemPorMunicipio[municipio]) {
          contagemPorMunicipio[municipio]++;
        } else {
          contagemPorMunicipio[municipio] = 1;
        }
      });

      worksheet.addRow([]);

      // TOTAL GERAL mesclado de C até K para centralizar abaixo da tabela
      const rowTotal = worksheet.addRow(['', '', `TOTAL GERAL: ${totalRegistros}`, '', '', '', '', '', '', '', '']);
      rowTotal.font = { bold: true, size: 11 };
      // Preenche o fundo das colunas (mantém estilo)
      for (let col = 3; col <= 11; col++) {
        rowTotal.getCell(col).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFE8F4F8' }
        };
      }
      // Mescla C:K para exibir o título centralizado abaixo da tabela
      worksheet.mergeCells(`C${rowTotal.number}:K${rowTotal.number}`);
      const cellRowTotal = rowTotal.getCell('C');
      // centraliza e permite quebra de linha para evitar corte
      cellRowTotal.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      // aumenta altura da linha para caber texto em dispositivos com fonte maior
      rowTotal.height = 22;

      worksheet.addRow([]);

      let dataInicioFormatada = 'N/A';
      let dataFimFormatada = 'N/A';

      if (this.filtroDataInicio) {
        const [ano, mes, dia] = this.filtroDataInicio.split('-');
        dataInicioFormatada = `${dia}/${mes}/${ano}`;
      }

      if (this.filtroDataFim) {
        const [ano, mes, dia] = this.filtroDataFim.split('-');
        dataFimFormatada = `${dia}/${mes}/${ano}`;
      }

      const rowPeriodo = worksheet.addRow(['', '', `Período: ${dataInicioFormatada} até ${dataFimFormatada}`, '', '', '', '', '', '', '', '', '']);

      // Mescla as células do período (de C até K)
      worksheet.mergeCells(`C${rowPeriodo.number}:K${rowPeriodo.number}`);

      // Estiliza a célula mesclada do período
      const cellPeriodo = rowPeriodo.getCell('C');
      cellPeriodo.font = {
        bold: true,
        size: 11,
        color: { argb: 'FF0062CC' } // Azul
      };
      cellPeriodo.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      };
      cellPeriodo.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFE8F4F8' } // Azul claro
      };
      cellPeriodo.border = {
        top: { style: 'thin', color: { argb: 'FF0062CC' } },
        left: { style: 'thin', color: { argb: 'FF0062CC' } },
        bottom: { style: 'thin', color: { argb: 'FF0062CC' } },
        right: { style: 'thin', color: { argb: 'FF0062CC' } }
      };

      rowPeriodo.height = 25;

      worksheet.pageSetup = {
        orientation: 'portrait',
        paperSize: 9, // A4
        // fitToPage=true com fitToWidth=1 e sem fitToHeight faz o Excel interpretar "Ajustar todas as colunas em uma página"
        fitToPage: true,
        fitToWidth: 2,
        // omitimos fitToHeight para evitar forçar 1 página de altura
        margins: {
          top: 0.1,
          bottom: 0.1,
          left: 0.1,
          right: 0.1,
          header: 0,
          footer: 0
        },
        horizontalCentered: true
      };

      const targetColsStart = 3; // primeira coluna de dados (C)
      const targetColsEnd = 11;  // última coluna de dados (K)
      const widths: number[] = [];

      for (let col = targetColsStart; col <= targetColsEnd; col++) {
        const column = worksheet.getColumn(col);
        let maxLength = 0;
        // inclui todas as células já escritas nesta coluna
        column.eachCell((cell: any) => {
          const cellValue = cell && cell.value !== undefined && cell.value !== null ? String(cell.value) : '';
          if (cellValue.length > maxLength) maxLength = cellValue.length;
        });
        // adiciona uma pequena margem visual
        const proposed = Math.max(8, Math.min(40, Math.ceil(maxLength + 2)));
        widths.push(proposed);
      }

      // Limite aproximado de caracteres (em largura) que cabem confortavelmente em A4 retrato
      // Aumentei para 130 para dar mais espaço e reduzir cortes em colunas longas
      const maxPrintableChars = 130;
      const totalChars = widths.reduce((s, w) => s + w, 0);

      let normalized: number[] = widths;
      if (totalChars > maxPrintableChars) {
        const factor = maxPrintableChars / totalChars;
        normalized = widths.map(w => Math.max(6, Math.floor(w * factor)));
      }

      // Ajustes finos: garante larguras mínimas maiores para colunas que costumam cortar dados
      // Coluna 4 (ENDEREÇO), 6 (MUNICÍPIO), 7 (BAIRRO), 8 (SERVIÇO EXECUTADO)
      const minWidthOverrides: { [col: number]: number } = {
        4: 28,
        6: 18,
        7: 16,
        8: 20
      };

      // Aplica as larguras normalizadas às colunas (com overrides)
      for (let i = 0; i < normalized.length; i++) {
        const colIndex = targetColsStart + i;
        const colObj = worksheet.getColumn(colIndex);
        const forced = minWidthOverrides[colIndex];
        colObj.width = forced && forced > normalized[i] ? forced : normalized[i];
      }

      const tableWidth = normalized.reduce((s, v) => s + v, 0);
      const leftover = Math.max(0, maxPrintableChars - tableWidth);
      const leftForCols = Math.floor(leftover / 2);
      const leftCol1 = Math.max(3, Math.floor(leftForCols / 2));
      const leftCol2 = Math.max(3, leftForCols - Math.floor(leftForCols / 2));
      worksheet.getColumn(1).width = leftCol1;
      worksheet.getColumn(2).width = leftCol2;

      const increaseBy = 2; // número de pontos para aumentar

      let headerRowIndex = -1;
      worksheet.eachRow((row: any) => {
        row.eachCell((cell: any) => {
          const val = cell && cell.value ? String(cell.value).trim().toUpperCase() : '';
          if (val === 'ENDEREÇO' || val === 'ENDERECO') {
            headerRowIndex = row.number;
          }
        });
      });

      const lastRowIndex = worksheet.lastRow ? worksheet.lastRow.number : 0;

      // Se não encontrar o cabeçalho, usa 6 como fallback
      const startRow = headerRowIndex > 0 ? headerRowIndex + 1 : 6;

      for (let r = startRow; r <= lastRowIndex; r++) {
        const row = worksheet.getRow(r);
        // Aumenta apenas se a coluna 3 (número da linha/tabela '#') parecer um índice (número)
        const ident = row.getCell(3) && row.getCell(3).value ? String(row.getCell(3).value).trim() : '';
        if (/^\d+$/.test(ident)) {
          row.eachCell((cell: any) => {
            const existingFont = cell.font || {};
            const newSize = existingFont.size ? (existingFont.size + increaseBy) : 11;
            cell.font = { ...existingFont, size: newSize };
          });
        }
      }

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const hoje = new Date();
      const dataArquivo = `${String(hoje.getDate()).padStart(2, '0')}-${String(hoje.getMonth() + 1).padStart(2, '0')}-${hoje.getFullYear()}`;

      // Define o sufixo baseado no status filtrado
      const statusSufixo = this.filtroStatus === 'Negada' || this.filtroStatus === 'Negado'
        ? 'negativas'
        : 'concluidas';

      const nomeArquivo = `relatorio-vistorias-${statusSufixo}_${dataArquivo}.xlsx`;

      saveAs(blob, nomeArquivo);

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
    }
  }
}
